module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "update-status"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("StatStatus.titleArchived")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("StatStatus.contentArchived")) + " " + _vm._s(_vm.action.archived ? _vm.$t("StatStatus.labelDesarchived") : _vm.$t("StatStatus.labelArchived")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("StatStatus.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateThisArchive(_vm.action);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.action.archived ? _vm.$t("StatStatus.labelDesarchived") : _vm.$t("StatStatus.labelArchived")) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-851f8322","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planos/actions/UpdateArchive.vue
// module id = 3302
// module chunks = 0